
import { CreateOperationReply } from '@/backend/express/controllers/operationController';
import { EquipmentItem } from '@/backend/models/equipmentItem';
import { useEquipmentStore } from '@/frontend/store/EquipmentStore';
import { I18n } from '@/i18n/I18n';
import { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { BasicButton } from '../buttons/BasicButton';
import { Select } from '../Select';

export function AddEquipmentButton(props: {
  onCreate: (equipmentId: string) => Promise<CreateOperationReply>
}) {
  const { onCreate } = props;
  const [showEquipmentModal, setShowEquipmentModal] = useState<boolean>(false);

  const handleSave = async (equipmentId: string) => {
    void onCreate(equipmentId);
    setShowEquipmentModal(false);
  };  

  return (
  <>
    <div className='d-flex'>
      <BasicButton
        className='btn btn-sm btn-secondary'
        label={I18n.get('addEquipment')}
        onClick={() => setShowEquipmentModal(true)}
      />
    </div>
    {showEquipmentModal &&  <EquipmentAddModal onClose={() => setShowEquipmentModal(false)} onSave={(equipmentId) => void handleSave(equipmentId)} />}
  </>
  );
}

function EquipmentAddModal(props: { onClose: () => void, onSave: (equipmentId: string) => void }) {
  const { onClose, onSave } = props;
  const [selectedEquipment, setSelectedEquipment] = useState<EquipmentItem | null>(null);

  return (
    <Modal show onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>{I18n.get('addEquipmentOperation')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className='my-3'>
          <SelectEquipment onSelect={setSelectedEquipment} />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>{I18n.get('cancel')}</Button>
        <Button type="submit" variant="primary" onClick={() => onSave(selectedEquipment?.id || '')} disabled={!selectedEquipment}>{I18n.get('confirm')}</Button>
      </Modal.Footer>
    </Modal>
  );
}

export function SelectEquipment(props: { onSelect: (equipment: EquipmentItem) => void }) {
  const { onSelect } = props;
  const equipmentList = useEquipmentStore(state => state.equipmentList);
  const [value, setValue] = useState<string>(I18n.get('select'));

  const handleSelect = (equipment: EquipmentItem) => {
    setValue(equipment.name);
    onSelect(equipment);
  };

  return (
    <div>
      <Form.Label>{I18n.get('selectEquipment')}</Form.Label>
      <Select label={I18n.get('selectEquipment')} value={value} minWidth="80px">
        {equipmentList.map((equipment) => <button className="dropdown-item" key={equipment.id} type="button" onClick={() => handleSelect(equipment)}>{equipment.name}</button>)}
      </Select>
    </div>
  );
}
